export default function setValues({ state }, values) {
  Object.keys(values).forEach((key) => {
    state.set(['onboarding', 'formData', key], values[key]);
  });
}
